// Salesforce form controller
function sfCtrl($window, $location, $element, $cookies) {
  const { dataLayer } = $window;
  const vm = this;

  vm.formInputs = {};
  vm.formView = false;
  vm.thankYouView = false;
  vm.config = {
    retUrl: $location.href,
    actionUrl: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
    formName: $element.find('form').attr('id'),
    triedSubmit: false
  };

  vm.sfCheckHash = () => {
    $element.find('.thankYouView').css('visibility', 'visible');
    $element.find('.retURL').attr('value', vm.config.retUrl);

    //if session var exists
    if (sessionStorage.formSubmitted === 'true') {
      vm.thankYouView = true;
      vm.expertCheck();
      //destroy session var
      sessionStorage.removeItem('formSubmitted');
    } else {
      vm.formView = true;
    }
  };

  vm.sfSubmit = (formValid) => {
    const version = $cookies.get('version') || 'v1';

    if (version === 'v2') $element.find('#sfRecordType').val('01270000000EAWZ');

    if (formValid) {
      // create session variable
      sessionStorage.formSubmitted = 'true';

      dataLayer.push({
        event: 'formSubmit',
        formName: vm.config.formName
      });

      $element
        .find('form')
        .attr('action', vm.config.actionUrl)
        .submit();
    } else {
      vm.config.triedSubmit = true;
    }
  };

  vm.expertCheck = () => {
    if ($('.apps-experts-post').length > 0) {
      $(window).on('load', () => {
        $('.right-panel .formmodal-trigger').click();
      });
    } else if ($('.experts-rollup').length > 0) {
      $(window).on('load', () => {
        $('.js-sfTrigger.becomeanexpertmodal-trigger').click();
      });
    }
  };

  vm.sfCheckHash();
}

sfCtrl.$inject = ['$window', '$location', '$element', '$cookies'];

export default sfCtrl;
